import React from "react";
import { Brand } from "@/components/Layout";
import { SECRET_POWERS } from "@/data/superCerveau";
import { weekDays, fmtShort, dayXp, dayHasData, scaleOf, momentsOf, momentsTrend, labQuestionOf } from "./scShared";
import { DIRE_QUESTIONS } from "./ScDire";
import { buildSynthese, SyntheseBody } from "./ScSynthese";

const Row = ({ label, value }) => (
  <tr><td className="py-1.5 pr-3 font-semibold text-[#4A3B36] align-top w-56">{label}</td><td className="py-1.5 text-[#4A3B36]">{value || "—"}</td></tr>
);

export default function ScPdf({ state, wk, week, innerRef }) {
  const days = weekDays(wk);
  const ENERGY = scaleOf(state);
  const trend = momentsTrend(days.map((k) => state.days[k]).filter(Boolean), momentsOf(state));
  const total = days.reduce((a, k) => { const d = state.days[k]; if (!d) return a; const x = dayXp(d, state); return { e: a.e + x.enfant, p: a.p + x.parent, r: a.r + (d.rappelsEvites || 0) }; }, { e: 0, p: 0, r: 0 });
  const secret = SECRET_POWERS.find((s) => s.id === week.secret);
  const syn = buildSynthese(state, wk, week);
  return (
    <div ref={innerRef} className="bg-white text-[#4A3B36] p-8" style={{ width: 794, fontFamily: "Georgia, serif" }} data-testid="sc-pdf-content">
      <div className="text-center mb-6"><Brand /></div>
      <h1 className="text-2xl font-bold text-center mb-1">Mission « Super-Cerveau » — Carnet de la semaine</h1>
      <p className="text-center text-sm mb-6">Semaine du {fmtShort(days[0])} au {fmtShort(days[6])} · Joueur : {state.setup.childName || "—"} · Coéquipier : {state.setup.parentName || "—"}</p>

      <table className="w-full text-xs border-collapse mb-6">
        <thead><tr className="bg-[#EFE7DD]">{["Jour", "Énergie", "Super-pouvoir", "Obstacle", "Montagne", "Arme testée", "XP"].map((h) => <th key={h} className="p-2 text-left border border-[#E5DCD1]">{h}</th>)}</tr></thead>
        <tbody>
          {days.map((k) => { const d = state.days[k]; const x = d ? dayXp(d, state) : { enfant: 0, parent: 0 }; return (
            <tr key={k}>
              <td className="p-2 border border-[#E5DCD1] font-semibold">{fmtShort(k)}</td>
              <td className="p-2 border border-[#E5DCD1]">{dayHasData(d) ? ENERGY.find((e) => e.id === d.energie)?.label || "—" : "—"}</td>
              <td className="p-2 border border-[#E5DCD1]">{d?.pouvoir || "—"}</td>
              <td className="p-2 border border-[#E5DCD1]">{d?.obstacle || "—"}</td>
              <td className="p-2 border border-[#E5DCD1]">{d?.boss || "—"}</td>
              <td className="p-2 border border-[#E5DCD1]">{d?.arme || "—"}</td>
              <td className="p-2 border border-[#E5DCD1]">{x.enfant} / {x.parent}</td>
            </tr>
          ); })}
        </tbody>
      </table>
      <p className="text-sm mb-6"><strong>Total de la semaine :</strong> {total.e} XP enfant · {total.p} XP coéquipier · {total.r} rappel(s) évité(s){secret ? ` · Super-pouvoir secret : ${secret.name} (${secret.desc})` : ""}</p>

      <div className="grid grid-cols-3 gap-4 mb-6 text-sm">
        {[["Les 3 super-pouvoirs", week.topPouvoirs], ["Les 3 obstacles", week.topObstacles], ["Les montagnes infranchissables", week.topBoss]].map(([t, arr]) => (
          <div key={t} className="rounded-xl border border-[#E5DCD1] p-3"><div className="font-bold mb-1">{t}</div><ol className="list-decimal pl-4">{arr.map((v, i) => <li key={i}>{v || "…"}</li>)}</ol></div>
        ))}
      </div>

      <h2 className="text-lg font-bold mb-2">Le laboratoire — « {labQuestionOf(state)} »</h2>
      <table className="text-sm mb-2"><tbody>
        {Object.entries(week.lab).filter(([, v]) => v.enfant || v.parent).map(([arme, v]) => <Row key={arme} label={arme} value={`Enfant ${"★".repeat(v.enfant || 0)}${"☆".repeat(5 - (v.enfant || 0))} · Parent ${"★".repeat(v.parent || 0)}${"☆".repeat(5 - (v.parent || 0))}`} />)}
        <Row label="Je garde" value={week.garde} /><Row label="Je laisse tomber" value={week.laisse} /><Row label="Je veux tester" value={week.teste} />
      </tbody></table>

      {week.dire?.on && (
        <>
          <h2 className="text-lg font-bold mt-6 mb-2">Envie de se dire des choses</h2>
          <table className="w-full text-xs border-collapse mb-2">
            <thead><tr className="bg-[#EFE7DD]"><th className="p-2 text-left border border-[#E5DCD1]">Question</th><th className="p-2 text-left border border-[#E5DCD1]">{state.setup.childName || "Enfant"}</th><th className="p-2 text-left border border-[#E5DCD1]">{state.setup.parentName || "Parent"}</th></tr></thead>
            <tbody>{DIRE_QUESTIONS.map((q) => <tr key={q.id}><td className="p-2 border border-[#E5DCD1] font-semibold">{q.id === "trop" ? "Trop entendu cette semaine" : q.id === "pas" ? "Pas assez entendu" : q.id === "exag" ? "Exagéré chez moi" : "Pas exagéré chez l'autre"}</td><td className="p-2 border border-[#E5DCD1]">{week.dire.enfant?.[q.id] || "—"}</td><td className="p-2 border border-[#E5DCD1]">{week.dire.parent?.[q.id] || "—"}</td></tr>)}</tbody>
          </table>
        </>
      )}

      {trend.length > 0 && (
        <>
          <h2 className="text-lg font-bold mb-2">Tendance des temps forts</h2>
          <table className="w-full text-xs border-collapse mb-6"><thead><tr className="bg-[#EFE7DD]"><th className="p-2 text-left border border-[#E5DCD1]">Moment</th><th className="p-2 border border-[#E5DCD1]">Jours notés</th><th className="p-2 border border-[#E5DCD1]">Compliqué</th><th className="p-2 border border-[#E5DCD1]">Devinettes réussies</th></tr></thead>
            <tbody>{trend.map((m) => <tr key={m.id}><td className="p-2 border border-[#E5DCD1]">{m.emoji} {m.label}</td><td className="p-2 border border-[#E5DCD1] text-center">{m.total}</td><td className="p-2 border border-[#E5DCD1] text-center">{m.hard}</td><td className="p-2 border border-[#E5DCD1] text-center">{m.matches}</td></tr>)}</tbody></table>
        </>
      )}
      <h2 className="text-lg font-bold mb-2">La synthèse de la semaine</h2>
      <div className="mb-6"><SyntheseBody s={syn} state={state} testid="sc-pdf-synthese" /></div>

      <h2 className="text-lg font-bold mb-2">Cérémonie des héros</h2>
      <table className="text-sm"><tbody>
        <Row label="Ma meilleure victoire de la semaine" value={week.victoire} />
        <Row label="Badge remis" value={week.badge ? `🏅 ${week.badge}` : ""} />
        <Row label="Ce qu'on a appris sur mon cerveau" value={week.appris} />
      </tbody></table>
      <p className="mt-8 text-[10px] text-[#6E5C53] text-center">M2HAT Psychologie — Mission « Super-Cerveau » · Document généré localement, aucune donnée n'est transmise.</p>
    </div>
  );
}
